module.exports = __webpack_public_path__ + "img/No_Record@3x.f1b12bed.png";